<!-- 历史净值 - 单行数据 -->
<template>
  <div class="history-net-row">
    <div class="history-net-item left-date">{{item.date}}</div>
    <div class="history-net-item mid-rate"
      ><span>{{item.netValue}}</span><span class="red-dot"
      >{{`${isCurrency && item.navType === 0 ? '*' : ''}`}}</span></div>
    <div :class="isCurrency ? ['history-net-item', 'last-right'] : ['history-net-item', 'mid-rate']"
      :style="{ color: isCurrency ? getRateColor(item.historyNetValue) : '#000000'}"
      >{{`${$isEmpty(item.historyNetValue)
          ? '--' : (item.historyNetValue)}${isCurrency && !$isEmpty(item.historyNetValue)
          ? '%': ''}`}}</div>
    <div v-if="!isCurrency" class="history-net-item last-right"
      :style="{ color: getRateColor(item.rise)}"
      >{{item.rise}}</div>
  </div>
</template>

<script>
import tool from '@/utils/tool';

export default {
  name: 'history-net-row',

  props: {
    fundType: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isCurrency() {
      return this.fundType === 'currency';
    },
  },

  methods: {
    getRateColor: tool.getRateColor,
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
}
.history-net-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  font-size: 30px;
  color: #000000;
  line-height: 30px;
  padding: 20px 0 8px;
  .history-net-item {
    display: flex;
    font-family: DINAlternate-Bold;
  }
  .left-date {
    flex: 2;
    justify-content: flex-start;
  }
  .mid-rate {
    flex: 3;
    justify-content: center;
    font-family: DINAlternate-Bold;
    .red-dot {
      color: #ff4400;
      font-size: 30px;
    }
  }
  .last-right {
    flex: 3;
    justify-content: flex-end;
    font-family: DINAlternate-Bold;
  }
}
</style>
